import MultipleListsSharedView from './MultipleListsSharedView';

export default MultipleListsSharedView;
